import { Component, Input, OnInit, ElementRef, ViewChild, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { columnData, axisLabelRotate, legendPosition } from './basic-bar-interface';
import * as backgroundColor from '../../config/backgroundColor';
import * as color from '../../config/colors';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonService } from '../../service/common.service';
import { BasicBarService } from './basic-bar.service';
import { ECharts } from 'echarts'
import { initOpts } from '../../config/initOpts'
import { ChartResizeService } from '../../service/chart-resize.service';
import { ChartDarkModeService } from '../../service/chart-dark-mode.service';


@Component({
  selector: 'bcac-basic-bar',
  templateUrl: './basic-bar.component.html',
  styleUrls: ['./basic-bar.component.scss']
})

export class BasicBarComponent implements OnInit {

  constructor(
    private basicBarService: BasicBarService,
    private commonService: CommonService,
    private chartResizeService: ChartResizeService,
    private chartDarkModeService: ChartDarkModeService
  ) { }

  chartOption: any = this.basicBarService.getColumnChartDefaultOption();


  public _bcacChartTitle: { show: boolean, label: string } = {
    show: true,
    label: "图表标题"
  };
  _chartTitleColor = ''
  // 是否显示标题
  @Input()
  set bcacChartShowTitle(show: boolean) {
    this._bcacChartTitle.show = show;
  }

  @Input()
  set bcacChartTitleText(text: string) {
    this._bcacChartTitle.label = text;
    this._bcacChartFileName = text;
  }
  // 图文件名
  public _bcacChartFileName: string = "图表";
  @Input()
  set bcacChartFileName(fileName: string) {
    this._bcacChartFileName = fileName;
  }
  get bcacChartFileName() {
    return this._bcacChartFileName;
  }
  // 是否显示toolbox
  @Input()
  set bcacChartShowToolbox(show: boolean) {
    // this.basicBarService.changeToolboxShow(this.chartOption, show)
  }

  _selectList: { value: string | number, optList: { label: string, value: any }[] }[] = [];

  // 数据选择区域
  @Input()
  set bcacSelectList(selectList: any) {
    if (Array.isArray(selectList)) {
      if (selectList.length > 0 && (selectList[0].hasOwnProperty('value') && selectList[0].hasOwnProperty('optList'))) {
        this._selectList = selectList;
      } else {
        selectList = [];
        this._selectList = selectList;
      }
    } else {
      selectList = []
      this._selectList = selectList;
    }
  }

  public _bcacLegendPosition: legendPosition = 'bottom';
  @Input()
  set bcacLegendPosition(position: legendPosition) {
    this._bcacLegendPosition = position;

    this.basicBarService.changeLegendPosition(this.chartOption, position);
    this.updateOption()
  };
  // 输入是否显示图例
  @Input()
  set bcacChartShowLegend(bcacLegendShow: boolean) {

    this.basicBarService.changeLegendShow(this.chartOption, bcacLegendShow);
    this.updateOption()
  }
  isNotSingleData: boolean;

  // 输入tooltip的单位
  @Input()
  set bcacTooltipUnit(tooltipUnit: string) {
    this.basicBarService.changeTooltipUnit(this.chartOption, tooltipUnit)
    this.updateOption();
  }

  bcacData: any = null
  legendDataArr: any[] = [];
  // 图数据
  @Input()
  set bcacChartData(bcacData: columnData) {

    this.isNotSingleData = false;
    let legendDataArr = [];
    if (bcacData && bcacData.hasOwnProperty('seriesName')) {
      bcacData.seriesName.forEach(e => {
        legendDataArr.push({
          label: e,
          value: e,
          checked: true
        })
      })
      this.legendDataArr = legendDataArr;
    }
    this.basicBarService.changeChartData(this.chartOption, bcacData, this.barBackgroundShow)

    this.updateOption();
  }

  // 加载等待
  _bcacChartLoading: boolean = false;
  @Input()
  set bcacChartLoading(loading: boolean) {
    this._bcacChartLoading = loading;
  }


  // x轴Name
  @Input()
  set bcacXAxisName(xAxisName: string) {
    this.basicBarService.changeXAxisName(this.chartOption, xAxisName)
    this.updateOption();
  }
  // 输入y轴名
  @Input()
  set bcacYAxisName(yAxisName: string) {
    this.basicBarService.changeYAxisName(this.chartOption, yAxisName)
    this.updateOption();
  }
  // 输入y轴名距离
  @Input()
  set bcacYAxisNameGap(yAxisNameGap: number) {
    this.basicBarService.changeYAxisNameGap(this.chartOption, yAxisNameGap);
    this.updateOption();
  }
  // x轴label的旋转 
  @Input()
  set bcacXAxisLabelRotate(xAxisLabelRotate: axisLabelRotate) {
    this.basicBarService.changeXAxisLabelRotate(this.chartOption, xAxisLabelRotate);
    this.updateOption();
  }

  // x轴 label 自定义截取字符长度
  @Input()
  set bcacXAxisLabelFormat(xAxisLabelFormat: number[]) {
    this.basicBarService.setXAxisLabelFormat(this.chartOption, xAxisLabelFormat);
  }

  // y轴label的旋转
  @Input()
  set bcacYAxisLabelRotate(yAxisLabelRotate: axisLabelRotate) {
    this.basicBarService.changeYAxisLabelRotate(this.chartOption, yAxisLabelRotate);
    this.updateOption();
  }

  dataSourceSelectShow: boolean = false;  //数据源选择下拉框是否显示
  // 输入数据源下拉框数据
  @Input()
  set bcacDataSourceList(value: any[]) {
    if (Array.isArray(value) && value.length > 0) {
      this._selectList = value;
      this.dataSourceSelectShow = true;
    } else {
      this.dataSourceSelectShow = false;
    }
  }

  restoreIconShow: boolean = false;
  @Input()
  set bcacRestore(restoreFunction) {
    if (restoreFunction) {
      this.restoreIconShow = true;
      this.chartRestore = restoreFunction;

    }
  }

  @Input()
  set bcacSimplifyYAxis(isSimplifyYAxis: boolean) {
    if (isSimplifyYAxis === true) {
      this.basicBarService.openSimplifyYAxis(this.chartOption)
    }
  }

  singleSelectIconShow: boolean = false;  // interval选择按钮是否显示
  intervalData: any[] = []; //interval数据
  @Input()  //输入interval数据
  set bcacIntervalData(value: any[]) {
    if (Array.isArray(value) && value.length > 0) {
      this.intervalData = value;
      this.singleSelectIconShow = true;
      if (value.length == 1) {
        this.axisScaleChange(value[0].value);
        this.singleSelectIconShow = false;
      }
    } else {
      this.singleSelectIconShow = false;
    }
  }
  // 是否开启框选
  @Input()
  set bcacBrush(callback: ($event, ...args: any[]) => void) {
    let style = this.commonService.changeFontSize()
    this.basicBarService.changeBrushStatus(this.chartOption, style, callback);
  }
  excelIconShow: boolean = false;
  // 显示导出Excel图标
  @Input()
  set bcacExcel(callback: ($event, ...args: any[]) => void) {
    if (callback) {
      this.excelIconShow = true;
    }
    this.export = callback;
  }

  _cardBackgroundColor = "#FFF";
  @Input()
  set bcacCardBackgroundColor(cardBackground: string) {
    this._cardBackgroundColor = cardBackground;
  }

  @Input()
  set bcacChartBackgroundColor(chartBackground: string) {
    this.basicBarService.changeChartBackground(this.chartOption, chartBackground);
    this.updateOption();
  }

  isSmallMode: boolean = false;
  @Input()
  set bcacSmallMode(smallMode: boolean) {
    if (smallMode) {
      this.isSmallMode = true;
      this.changeCardPadding(smallMode);
      this.chartResizeService.openSmallMode(this.chartOption, this.isSmallMode, this._bcacLegendPosition);
      this.updateOption();
    } else {
      this.isSmallMode = false;
    }
  }

  @Input()
  set bcacAxisSplitLine(splitLineShow: boolean) {
    if (splitLineShow == true) {
      this.chartResizeService.configSplitLine(true, this.chartOption)
    } else {
      this.chartResizeService.configSplitLine(false, this.chartOption)
    }
  }

  _cardPadding = "1rem"
  @Input()
  set bcacCardPadding(cardPadding: string) {
    this.setCardPadding(cardPadding)
  }


  @Input()
  set bcacDarkMode(darkMode: boolean | string) {
    this.changeChartTitleColor(darkMode);
    this.changeCardBackgroundColor(darkMode);
    this.chartDarkModeService.openDarkMode(this.chartOption, darkMode)
  }

  @Input()
  set bcacColors(chartColors) {
    if (Array.isArray(chartColors)) {
      this.commonService.changeChartColors(this.chartOption, chartColors);
    }
  }
  // x轴formatter
  @Input()
  set bcacXAxisFormat(format: boolean) {
    if (format == true) {
      this.basicBarService.changeXAxisFormat(this.chartOption)
    }
  }

  @Input()
  set bcacYAxisMinInterval(minInterval: number) {
    this.basicBarService.changeYAxisMinInterval(this.chartOption, minInterval);
  }

  @Input()
  set bcacYAxisLabelSplitSwitch(splitSwitch) {
    if (splitSwitch == false) {
      this.basicBarService.changeYAxisLabelSplit(this.chartOption, splitSwitch)
    }
  }
  //Y轴min
  @Input()
  set bcacYAxisMin(min: number) {
    this.basicBarService.changeYAxisMin(this.chartOption, min);
  }
  @Input()
  set bcacYAxisMax(max: number) {
    this.basicBarService.changeYAxisMax(this.chartOption, max);
  }
  @Input()
  set bcacYAxisInterval(interval: number) {
    this.basicBarService.changeYAxisInterval(this.chartOption, interval);
  }

  barBackgroundShow: boolean = false;
  @Input()
  set bcacSeriesBackgroundShow(show: boolean) {
    this.barBackgroundShow = show;

    this.basicBarService.changeBarSeriesBackgroundStatus(this.chartOption, show);
  }

  //Y轴max
  //Y轴interval

  @Output() bcacGetChartInstance: EventEmitter<ECharts> = new EventEmitter<ECharts>();

  // 框选选中事件
  @Output() bcacBrushSelected: EventEmitter<any> = new EventEmitter<any>();

  // mouseover事件
  @Output() bcacMouseover: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  // 数据源选择变化
  @Output() bcacDataSourceSelectEmit: EventEmitter<any[]> = new EventEmitter<any[]>();

  initOpts;
  ngOnInit() {
    this.initOpts = initOpts;
    fromEvent(window, 'resize').pipe(debounceTime(200)).subscribe(() => {
      this.chartResizeService.autoResizeAdapt(this.optionInit, this.chartOption)

    })
  }

  // 更新配置
  updateOption() {
    if (this.optionInit) {
      this.optionInit.setOption(this.chartOption, true)
    }

  }
  // 框选
  chartBrushSelected($evnet) {
    this.bcacBrushSelected.emit($evnet);
  }

  selectedDataChange($event) {
    this.bcacData.forEach(element => {
      if (element.value === $event) {
        this.basicBarService.changeChartData(this.chartOption, element.data, this.barBackgroundShow)
        this.updateOption()
        return;
      }
    });
  }

  optionInit: ECharts;
  onOptionInit(ec) {
    this.optionInit = ec;
    this.bcacGetChartInstance.emit(ec);
  }

  selectedModelChange($event) {
    this.bcacDataSourceSelectEmit.emit($event);
  }

  // 坐标轴interval改变
  axisScaleChange(interval: any) {
    this.basicBarService.setInterval(this.chartOption, interval);
    this.updateOption();
  }
  // 图例更改
  legendChange(e) {
    this.basicBarService.topLegendChange(e, this.optionInit)
  }
  // 设置卡片的背景色
  setCardBackgroundColor() {
    if (this._cardBackgroundColor) {
      return this._cardBackgroundColor;
    } else {
      return '#FFF'
    }
  }
  // 设置卡片的padding
  setCardPadding(cardPadding) {
    switch (cardPadding) {
      case 'none':
        this._cardPadding = '0rem';
        break;
      default:
        this._cardPadding = '1rem'
        break;
    }
  }

  // 改变卡片padding
  changeCardPadding(smallMode: boolean) {
    if (smallMode) {
      this._cardPadding = '0rem';
    } else {
      this._cardPadding = '1rem';
    }
  }

  changeChartTitleColor(darkMode: boolean | string) {
    if (!darkMode) {
      this._chartTitleColor = ''
    } else {
      this._chartTitleColor = color.darkModeTextColor;
    }
  }

  changeCardBackgroundColor(darkMode: boolean | string) {
    if (typeof (darkMode) === 'string') {
      this._cardBackgroundColor = darkMode;
    } else if (darkMode) {
      this._cardBackgroundColor = backgroundColor.darkModeBGColor;
    }
  }

  // 图表restore
  chartRestore: (...args) => void = () => { }
  // 到处excel
  export: (...args) => void = () => { }
}
